<template lang="pug">
.u-align-left
  form.add_shipping(
    @submit.prevent='onSubmitShipping',
    :class='loadingClass',
    :data-vv-scope='scopeName'
  )
    .inner.grid-container
      template(v-for='(cols, i) in formOrder')
        .row(:key='"form-row" + i')
          .col(v-for='col in cols', :class='col.class')
            .form__item(
              :key='col.input.name',
              v-if='!(col.input.name === "label" && isNewCustomer)'
            )
              label(:for='"form-" + col.input.name')
                | {{ __(col.input.label) }}
                span.form-ctl__option(
                  v-if='col.input.required',
                  v-text='__("Required")'
                )
              template(v-if='col.input.name === "state"')
                vue-state-select(
                  :input-id='"form-" + col.input.name',
                  :input-class='{ "form-ctl": true }',
                  input-placeholder='Tokyo',
                  :input-tabindex='100 + col.tabindex',
                  :select-placeholder='__("- Select your state -")',
                  v-model='formData.state',
                  :country='formData.country',
                  :service='service',
                  :scope='scopeName',
                  :autocomplete='col.input.autocomplete'
                )

              template(v-else-if='col.input.name === "country"')
                template(v-if='col.input.readonly')
                  .form-ctl--static(
                    v-text='countries[formData[col.input.name]]'
                  )
                template(v-else)
                  v-select.c-vselect(
                    v-model='formData[col.input.name]',
                    :options='options',
                    :reduce='(country) => country.value',
                    :clearable='false',
                    placeholder='- Select your country -',
                    :id='"form-" + col.input.name',
                    :tabindex='100 + col.tabindex',
                    :name='col.input.name',
                    v-validate='col.input.validation',
                    :class='{ "form-ctl--valid": !!formData.country }',
                    :autocomplete='col.input.autocomplete',
                    @search='searchCountry',
                    @search:focus='searchCountryFocus',
                    @search:blur='searchCountryBlur'
                  )

              template(
                v-else-if='col.input.name === "zip" && formData.country === "JP"'
              )
                .input--addon-postfix
                  input.form-ctl(
                    :id='"form-" + col.input.name',
                    :type='col.input.type',
                    :name='col.input.name',
                    :tabindex='100 + col.tabindex',
                    :placeholder='__(col.input.placeholder)',
                    :autocomplete='col.input.autocomplete',
                    v-model='formData[col.input.name]',
                    v-validate='col.input.validation',
                    :data-vv-as='col.input.label.toLowerCase()'
                  )
                  .input__addon
                    button.c-btn.c-btn--primary(
                      type='button',
                      @click='searchZipcode'
                    ) 郵便番号検索
                .form-ctl__error(
                  v-show='errors.has(col.input.name, scopeName)',
                  v-text='errors.first(col.input.name, scopeName)'
                )
                .form-ctl__error(
                  v-show='errors.has(col.input.name, \'server\')',
                  v-text='errors.first(col.input.name, "server")'
                )
                .u-block.u-mtxs
                  a(
                    href='http://www.post.japanpost.jp/zipcode/',
                    target='_blank'
                  ) 郵便番号がわからないときは

              template(v-else)
                input.form-ctl(
                  :id='"form-" + col.input.name',
                  :type='col.input.type',
                  :name='col.input.name',
                  :tabindex='100 + col.tabindex',
                  :placeholder='__(col.input.placeholder)',
                  :autocomplete='col.input.autocomplete',
                  v-model='formData[col.input.name]',
                  v-validate='col.input.validation',
                  :data-vv-as='col.input.label.toLowerCase()',
                  :class='{ "form-ctl--valid": !!formData[col.input.name] && col.input.name === "city" }'
                )
                .form-ctl__error(
                  v-show='errors.has(col.input.name, scopeName)',
                  v-text='errors.first(col.input.name, scopeName)'
                )
                .form-ctl__error(
                  v-show='errors.has(col.input.name, \'server\')',
                  v-text='errors.first(col.input.name, "server")'
                )

      .form__item.row.error(v-show='errors.has(\'general\', \'server\')') {{ errors.first('general', 'server') }}
      .form__item.row
        .col.l4.s12
          button.c-btn.c-btn--primary.c-btn--lg.c-btn--fill(
            type='submit',
            tabindex='120',
            :disabled='errors.any(scopeName) || errors.any("server")',
            v-text='__(buttonLabel)'
          )
</template>
<script>
// 使用時はcontainer側で
// import VeeValidate from 'vee-validate';
// Vue.use(VeeValidate);
// を追加する必要がある
import Vue from 'vue';
import VueSelect from 'vue-select';

import isPlainObject from 'latest_modules/lodash/isPlainObject';
import merge from 'latest_modules/lodash/merge';
import countries from '../../../../../../lib/service/payment/data/countries.json';

import { SERVICES, SERVICES_PATTERN } from '../../constants/service';
import { LANG_CODES } from '../../constants/app';
import { I18n } from '../../util/mixin/i18n.mixin';

import shippingStateSelect from './ShippingStateSelect.vue';
import axios from '../../api/common/axios';

Vue.component('v-select', VueSelect);

const INPUTS = {
  LABEL: {
    name: 'label',
    label: 'Shipping Nickname',
    type: 'text',
    placeholder: 'Home, Work, Aunt Jane',
    validation: 'max:100'
  },
  NAME: {
    name: 'name',
    label: 'Full Name',
    type: 'text',
    required: true,
    placeholder: 'Full Name',
    validation: 'required|max:100'
  },
  FIRST_NAME: {
    name: 'first_name',
    label: 'First Name',
    type: 'text',
    required: true,
    placeholder: 'First Name',
    validation: 'required|max:100'
  },
  LAST_NAME: {
    name: 'last_name',
    label: 'Last Name',
    type: 'text',
    required: true,
    placeholder: 'Last Name',
    validation: 'required|max:100'
  },
  COUNTRY: {
    name: 'country',
    label: 'Country',
    type: 'select',
    required: true,
    placeholder: '',
    autocomplete: 'country',
    validation: 'required'
  },
  LINE1: {
    name: 'line1',
    label: 'Address Line 1',
    type: 'text',
    required: true,
    placeholder: 'Street Address',
    autocomplete: 'address-line1',
    validation: 'required|max:60'
  },
  LINE2: {
    name: 'line2',
    label: 'Address Line 2',
    type: 'text',
    autocomplete: 'address-line2',
    placeholder: 'Apt / Unit / Suite / Other',
    validation: 'max:60'
  },
  CITY: {
    name: 'city',
    label: 'City',
    type: 'text',
    required: true,
    placeholder: 'City',
    autocomplete: 'address-level2',
    validation: 'required|max:36'
  },
  STATE: {
    name: 'state',
    label: 'State/Province',
    autocomplete: 'address-level1',
    required: true
  },
  ZIP: {
    name: 'zip',
    label: 'Zip Code',
    type: 'text',
    required: true,
    placeholder: 'e.g. 0000000',
    autocomplete: 'postal-code',
    validation: 'required|max:20'
  },
  TEL: {
    name: 'tel',
    label: 'Telephone Number',
    type: 'text',
    required: true,
    placeholder: 'e.g. 0123456789',
    autocomplete: 'tel',
    validation: 'required|regex:^([0-9-]+)$|max:20'
  },
  TAX_CODE: {
    name: 'tax_code',
    label: 'Tax Number',
    type: 'text',
    required: true,
    placeholder: 'Tax Number',
    validation: 'required|max:25'
  }
};

export default {
  mixins: [I18n],
  components: {
    'vue-state-select': shippingStateSelect
  },
  props: {
    // 使用するサービス名
    // 'shop' or 'subscription' default: ''
    // サービス名を指定すると自動的にそのサービスで使用するデフォルトの住所に変更されます
    // 住所変更などデフォルトを変更せず参照のみを行う場合は、 service を指定しないこと
    service: {
      type: String,
      default: ''
    },
    shippingId: {
      type: String,
      default: ''
    },
    skipAdd: {
      type: Boolean,
      default: false
    },
    buttonLabel: {
      type: String,
      default: 'Submit'
    },
    selectableCountries: {
      type: Array,
      default: null
    },
    skipChangeCurrent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scopeName: 'shipping-address',
      loading: false,
      countries: countries,
      options: [],
      formData: {
        _id: '',
        label: '',
        name: '',
        first_name: '',
        last_name: '',
        country: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        zip: '',
        tel: '',
        tax_code: ''
      },
      conf: tom.conf,
      isSearchCountryFocus: false
    };
  },
  watch: {
    'formData.country'() {
      this.formData.state = '';
    },
    formData: {
      handler() {
        this.errors.clear('server');
      },
      deep: true
    },
    shippingId() {
      this.setShippingId(this.shippingId);
    }
  },
  computed: {
    loadingClass() {
      return {
        loading: this.loading,
        'loading--opacity': this.loading
      };
    },
    isEdit() {
      return !(this.shippingId === null);
    },
    inputConfig() {
      const inputConfig = {};
      if (this.service === 'projects') {
        Object.assign(inputConfig, {
          TEL: {
            validation: 'required|max:22'
          }
        });
      }

      if (this.formData.country === 'US' || this.formData.country === 'CA') {
        Object.assign(inputConfig, {
          TEL: {
            validation: 'required|regex:^([0-9-]+)$|max:10'
          }
        });
      }
      return inputConfig;
    },
    formOrder() {
      // Object.assign ではネストされたオブジェクトを再帰的にマージできないので _.merge を使用
      const inputs = merge({}, INPUTS, this.inputConfig);
      let rows = [];
      if (inputs.LABEL.ignore !== true) {
        rows.push([
          {
            input: inputs.LABEL,
            class: 'm6 s12',
            tabindex: 1
          }
        ]);
      }
      rows.push([
        {
          input: inputs.COUNTRY,
          class: 'm6 s12',
          tabindex: 2
        }
      ]);
      if (this.service === SERVICES.PROJECTS) {
        if (this.formData.country === 'JP') {
          rows.push([
            {
              input: inputs.LAST_NAME,
              class: 's6',
              tabindex: 3
            },
            {
              input: inputs.FIRST_NAME,
              class: 's6',
              tabindex: 4
            }
          ]);
        } else {
          rows.push([
            {
              input: inputs.FIRST_NAME,
              class: 's6',
              tabindex: 3
            },
            {
              input: inputs.LAST_NAME,
              class: 's6',
              tabindex: 4
            }
          ]);
        }
      } else {
        rows.push([
          {
            input: inputs.NAME,
            class: 'm6 s12',
            tabindex: 3
          }
        ]);
      }
      if (this.formData.country === 'JP') {
        rows.push([
          {
            input: inputs.ZIP,
            class: 'm6 s12',
            tabindex: 5
          }
        ]);
        rows.push([
          {
            input: inputs.STATE,
            class: 'm6 s12',
            tabindex: 6
          }
        ]);
        rows.push([
          {
            input: inputs.CITY,
            class: 'm9 s12',
            tabindex: 7
          }
        ]);
        rows.push([
          {
            input: inputs.LINE1,
            class: 'm9 s12',
            tabindex: 8
          }
        ]);
        rows.push([
          {
            input: inputs.LINE2,
            class: 'm9 s12',
            tabindex: 9
          }
        ]);
        rows.push([
          {
            input: inputs.TEL,
            class: 'm6 s12',
            tabindex: 10
          }
        ]);
      } else {
        rows.push([
          {
            input: inputs.LINE1,
            class: 'm9 s12',
            tabindex: 5
          }
        ]);
        rows.push([
          {
            input: inputs.LINE2,
            class: 'm9 s12',
            tabindex: 6
          }
        ]);
        rows.push([
          {
            input: inputs.CITY,
            class: 'm4 s12',
            tabindex: 7
          },
          {
            input: inputs.STATE,
            class: 'm5 s6',
            tabindex: 8
          },
          {
            input: inputs.ZIP,
            class: 'm3 s6',
            tabindex: 9
          }
        ]);
        rows.push([
          {
            input: inputs.TEL,
            class: 'm6 s12',
            tabindex: 10
          }
        ]);
      }
      if (['BR', 'AR', 'EC'].includes(this.formData.country)) {
        rows.push([
          {
            input: inputs.TAX_CODE,
            class: 'm6 s12',
            tabindex: 11
          }
        ]);
      }
      return rows;
    },
    SERVICES() {
      return SERVICES;
    },
    isNewCustomer() {
      return window.tom.user.isNewCustomer;
    },
    lang() {
      if (this.conf.lang && this.conf.lang.indexOf('ja') > -1) {
        return 'ja';
      } else {
        return 'en';
      }
    }
  },
  created() {
    this.$validator.reset();
    if (this.service && SERVICES_PATTERN.includes(this.service)) {
      this.$store.dispatch('shippings/setService', this.service);
    }

    // access_country_codeでcountryを入力補完
    if (window.tom.conf.access_country_code) {
      this.formData.country = window.tom.conf.access_country_code;
    } else if (this.$store.state.user.lang === LANG_CODES.JA) {
      this.formData.country = 'JP';
    }

    if (this.shippingId) {
      this.setShippingId(this.shippingId);
    }

    // v-select options用
    this.options = Object.entries(this.countries).map(([value, label]) => ({
      value,
      label
    }));
    if (this.selectableCountries) {
      this.options = this.options.filter(({ value }) =>
        this.selectableCountries.includes(value)
      );
    }
  },
  methods: {
    /*
    User Action
      */
    // Submit した
    onSubmitShipping() {
      // スペースが含まれていない場合にダイアログを表示
      const nameParts = this.formData.name.trim().split(/\s+/);
      if (nameParts && nameParts.length > 1) {
        this.submit();
        return;
      } else {
        const message = `Your name, ${this.formData.name}, may be missing a last name. Please ensure that we have your full name.`;
        const options = {
          ok: 'Confirm as-is',
          cancel: 'Go back and fix',
          clickToClose: true
        };
        this.$confirm(message, options)
          .then(() => {
            this.submit();
          })
          .catch(() => {});
      }
    },
    submit() {
      this.$validator.validateAll(this.scopeName).then((result) => {
        // 電話番号にハイフンが含まれる場合は削除
        const regex = '^([0-9-]+)$';
        if (this.formData.tel.match(regex)) {
          this.formData.tel = this.formData.tel.replace(/-/g, '');
        }

        if (!['BR', 'AR', 'EC'].includes(this.formData.country)) {
          this.formData.tax_code = '';
        }

        // ローカルのバリデーションが通った場合
        if (result) {
          if (this.skipAdd) {
            return this.$emit('submit');
          }

          this.add(this.formData)
            .then(() => {
              this.errors.clear('server');
              this.clear();
            })
            .catch((err) => {
              this.loading = false;
              if (err) {
                this.$validator.validateAll();
                this.setError(err);
              }
            });
        }
      });
    },

    /*
      Public methods
        */
    // 新しい住所を登録する
    add(data) {
      this.loading = true;
      return this.$store
        .dispatch('shippings/add', data)
        .then((res) => {
          if (this.skipChangeCurrent) {
            return Promise.resolve(res);
          }
          // service が設定されていれば default を更新する
          if (this.service) {
            return this.$store.dispatch('shippings/changeCurrent', {
              _id: res._id
            });
          }
          return Promise.resolve(res);
        })
        .then((res) => {
          this.$emit('submit', res);
        })
        .then(() => {
          this.loading = false;
        });
    },
    setError(err) {
      if (isPlainObject(err)) {
        this.setErrorBag(err);
      } else if (err.message) {
        // Internal Serverエラー等
        this.setErrorBag({
          general: {
            msg: err.message
          }
        });
      } else {
        alert('Network error.');
      }
    },
    setErrorBag(err) {
      // スコープ内のエラーを全て削除してからAPIのエラーを設定
      this.clearError();
      Object.keys(err).forEach((key) => {
        // 要ログインエラー・Shippoのエラー等
        if (key === 'general') {
          this.errors.add({
            field: key,
            msg: err[key].msg || err[key],
            rule: '',
            scope: 'server'
          });
        } else {
          // バリデーションエラー
          this.errors.add({
            field: key,
            msg: err[key].msg,
            rule: '',
            scope: 'server'
          });
        }
      });
    },
    clear() {
      // フォームの内容を空にする
      const addressItems = [
        'label',
        'country',
        'name',
        'first_name',
        'last_name',
        'line1',
        'line2',
        'city',
        'state',
        'zip',
        'tel',
        'tax_code'
      ];
      this.$validator.pause();
      addressItems.forEach((key) => {
        this.formData[key] = '';
      });
      this.$nextTick(() => {
        this.$validator.resume();
      });
    },
    setShippingId(shippingId) {
      // 既存住所を取得してフォームに反映する（住所変更時）
      const address = this.$store.getters['shippings/findById'](shippingId);
      this.clearError();
      this.formData = Object.assign(this.formData, address); //cloneDeepすることでVuexエラー回避
      // formData.countryのwatchでformData.stateがクリアされるため、遅延してformData.stateに代入
      this.$nextTick(() => {
        this.formData.state = address.state;
      });
    },
    clearError() {
      this.errors.clear(this.scopeName);
    },
    searchZipcode() {
      if (!this.formData.zip || this.formData.country !== 'JP') {
        return;
      }
      return axios
        .get('/cart/japanese_address', {
          params: {
            zip_code: this.formData.zip
          }
        })
        .then((res) => {
          if (!res.data || !res.data.address) {
            return;
          }
          const address = res.data.address;
          if (address.prefecture_name) {
            this.formData.state = address.prefecture_name;
          }
          if (address.city_name) {
            this.formData.city = address.city_name;
          }
          if (address.town_name) {
            this.formData.line1 = address.town_name;
          }
        })
        .catch(() => {
          return;
        });
    },

    /**
     * VueSelect をブラウザの自動入力に対応させるための処理
     */
    searchCountryFocus() {
      this.isSearchCountryFocus = true;
    },
    searchCountryBlur() {
      this.isSearchCountryFocus = false;
    },
    searchCountry(value) {
      if (!this.isSearchCountryFocus || !value) {
        return;
      }

      for (const [key, val] of Object.entries(this.countries)) {
        if (val === value || key === value) {
          this.formData.country = key;
          break;
        }
      }
    }
  }
};
</script>
